import React, { useState } from 'react';
import { Modal } from '../../../components/Modal';
import type { SubscriptionAssignment } from '../types';

type AssignmentEndDateModalProps = {
  assignment: SubscriptionAssignment;
  onCancel: () => void;
  onSubmit: (date: Date | null) => void;
  submitting: boolean;
};

export function AssignmentEndDateModal({ assignment, onCancel, onSubmit, submitting }: AssignmentEndDateModalProps) {
  const [endDate, setEndDate] = useState(() =>
    assignment.endAt ? new Date(assignment.endAt).toISOString().slice(0, 16) : ''
  );

  const handleSave = (dateValue: string | null) => {
    const parsed = dateValue ? new Date(dateValue) : null;
    onSubmit(parsed);
  };

  return (
    <Modal
      title="Edit end date"
      onClose={onCancel}
      size="sm"
      footer={
        <>
          <button type="button" className="btn btn-outline-secondary" onClick={onCancel} disabled={submitting}>
            Cancel
          </button>
          <button type="button" className="btn btn-outline-danger" onClick={() => handleSave(null)} disabled={submitting}>
            Clear end date
          </button>
          <button type="button" className="btn btn-primary" onClick={() => handleSave(endDate)} disabled={submitting}>
            {submitting ? 'Saving…' : 'Save'}
          </button>
        </>
      }
    >
      <p className="mb-3">
        Update the expiration for {assignment.subscriptionName} ({assignment.subscriptionCode}).
      </p>
      <label className="form-label" htmlFor="assignmentEndDate">
        End date
      </label>
      <input
        id="assignmentEndDate"
        type="datetime-local"
        className="form-control"
        value={endDate}
        onChange={(event) => setEndDate(event.target.value)}
      />
    </Modal>
  );
}
